/* eslint-disable menti-react/forbidden-filename */
import type { ScalesData, ScalesScore } from './Scales';

export const getWeightedAverage = (scores: ScalesScore) => {
  let total = 0;
  let count = 0;
  let min = parseInt(Object.keys(scores)[0] ?? '0', 10);
  Object.entries(scores).forEach(([index, score]) => {
    const parsedIndex = parseInt(index, 10);
    if (parsedIndex < min) {
      min = parsedIndex;
    }
    total += score * parsedIndex;
    count += score;
  });

  return count === 0 ? min : total / count;
};

export const getOverallAverage = (data: ScalesData[], rangeMin: number) => {
  if (data.length === 0) {
    return 0;
  }

  const numberOfChoicesWithScore = data.filter((d) =>
    Object.values(d.score).some((score) => score > 0),
  ).length;

  const total = data.reduce((acc, d) => {
    const scores = d.score;
    const hasScores = Object.values(scores).some((score) => score > 0);
    if (hasScores) {
      return acc + getWeightedAverage(scores);
    }
    return acc;
  }, 0);

  return numberOfChoicesWithScore > 0
    ? total / numberOfChoicesWithScore
    : rangeMin;
};
